import React,{useState} from 'react'
import Top_heading from './component/Top_heading'
import Main_Heading from './services-component/Main_Heading'
import Component_Heading from './component/Component_Heading'
import dummy from './services-component/images/dummy.jpg'

export default function Blog() {

    const [activeTab, setActiveTab] = useState('Tab1');
      
    // Handle tab click
    const handleTabClick = (tab) => {
      setActiveTab(tab);
    };

    const renderContent = () => {
        switch (activeTab) {
          case 'Tab1':
            return (
                <>
                <div className="mainHeadingSection">
                    <h2>
                    DIGITAL MARKETING
                    </h2>
                </div>
                <div className="container latestBlogContainer">
                    <div className="row row-cols-3 latestBlogRow">
                        <div className="col LatestBlogCol">
                            <div className="mainAreaBlog">
                                <div className="BlogImgArea">
                                    <img src={dummy} alt="" />
                                </div>
                                <div className="BlogContain">
                                    <ul>
                                        <li>Digital Marketing, HubSpot Sales, CRM & Marketing, Lead Generation Strategy, HubSpot 2023</li>
                                         <li><div className='blogConatainWithPara'> AuthorCaryn Oram <p>DateFebruary 08, 2023</p></div></li>
                                    </ul>
                                    
                                    <h3>THE ROLE OF DATA IN DIGITAL MARKETING 
                                    IN 2023</h3>
                                </div>
                            </div>
                        </div>
                        <div className="col LatestBlogCol">
                            <div className="mainAreaBlog">
                                <div className="BlogImgArea">
                                    <img src={dummy} alt="" />
                                </div>
                                <div className="BlogContain">
                                    <ul>
                                        <li>Digital Marketing, HubSpot Sales, CRM & Marketing, Lead Generation Strategy, HubSpot 2023</li>
                                        <li><div className='blogConatainWithPara'> AuthorCaryn Oram <p>DateFebruary 08, 2023</p></div></li>
                                    </ul>
                                             
                                    <h3>THE ROLE OF DATA IN DIGITAL MARKETING 
                                    IN 2023</h3>
                                </div>
                            </div>
                        </div>
                        <div className="col LatestBlogCol">
                            <div className="mainAreaBlog">
                                <div className="BlogImgArea">
                                    <img src={dummy} alt="" />
                                </div>
                                <div className="BlogContain">
                                    <ul>
                                        <li>Digital Marketing, HubSpot Sales, CRM & Marketing, Lead Generation Strategy, HubSpot 2023</li>
                                         <li><div className='blogConatainWithPara'> AuthorCaryn Oram <p>DateFebruary 08, 2023</p></div></li>
                                    </ul>
                                    
                                    <h3>THE ROLE OF DATA IN DIGITAL MARKETING 
                                    IN 2023</h3>
                                </div>
                            </div>
                        </div>
                        <div className="col LatestBlogCol">
                            <div className="mainAreaBlog">
                                <div className="BlogImgArea">
                                    <img src={dummy} alt="" />
                                </div>
                                <div className="BlogContain">
                                    <ul>
                                        <li>Digital Marketing, HubSpot Sales, CRM & Marketing, Lead Generation Strategy, HubSpot 2023</li>
                                         <li><div className='blogConatainWithPara'> AuthorCaryn Oram <p>DateFebruary 08, 2023</p></div></li>
                                    </ul>
                                    
                                    <h3>THE ROLE OF DATA IN DIGITAL MARKETING 
                                    IN 2023</h3>
                                </div>
                            </div>
                        </div>
                        <div className="col LatestBlogCol">
                            <div className="mainAreaBlog">
                                <div className="BlogImgArea">
                                    <img src={dummy} alt="" />
                                </div>
                                <div className="BlogContain">
                                    <ul>
                                        <li>Digital Marketing, HubSpot Sales, CRM & Marketing, Lead Generation Strategy, HubSpot 2023</li>
                                         <li><div className='blogConatainWithPara'> AuthorCaryn Oram <p>DateFebruary 08, 2023</p></div></li>
                                    </ul>
                                    
                                    <h3>THE ROLE OF DATA IN DIGITAL MARKETING 
                                    IN 2023</h3>
                                </div>
                            </div>
                        </div>
                        <div className="col LatestBlogCol">
                            <div className="mainAreaBlog">
                                <div className="BlogImgArea">
                                    <img src={dummy} alt="" />
                                </div>
                                <div className="BlogContain">
                                    <ul>
                                        <li>Digital Marketing, HubSpot Sales, CRM & Marketing, Lead Generation Strategy, HubSpot 2023</li>
                                         <li><div className='blogConatainWithPara'> AuthorCaryn Oram <p>DateFebruary 08, 2023</p></div></li>
                                    </ul>
                                    
                                    <h3>THE ROLE OF DATA IN DIGITAL MARKETING 
                                    IN 2023</h3>
                                </div>
                            </div>
                        </div>
                        <div className="col LatestBlogCol">
                            <div className="mainAreaBlog">
                                <div className="BlogImgArea">
                                    <img src={dummy} alt="" />
                                </div>
                                <div className="BlogContain">
                                    <ul>
                                        <li>Digital Marketing, HubSpot Sales, CRM & Marketing, Lead Generation Strategy, HubSpot 2023</li>
                                         <li><div className='blogConatainWithPara'> AuthorCaryn Oram <p>DateFebruary 08, 2023</p></div></li>
                                    </ul>
                                    
                                    <h3>THE ROLE OF DATA IN DIGITAL MARKETING 
                                    IN 2023</h3>
                                </div>
                            </div>
                        </div>
                        <div className="col LatestBlogCol">
                            <div className="mainAreaBlog">
                                <div className="BlogImgArea">
                                    <img src={dummy} alt="" />
                                </div>
                                <div className="BlogContain">
                                    <ul>
                                        <li>Digital Marketing, HubSpot Sales, CRM & Marketing, Lead Generation Strategy, HubSpot 2023</li>
                                         <li><div className='blogConatainWithPara'> AuthorCaryn Oram <p>DateFebruary 08, 2023</p></div></li>
                                    </ul>
                                    
                                    <h3>THE ROLE OF DATA IN DIGITAL MARKETING 
                                    IN 2023</h3>
                                </div>
                            </div>
                        </div>
                        <div className="col LatestBlogCol">
                            <div className="mainAreaBlog">
                                <div className="BlogImgArea">
                                    <img src={dummy} alt="" />
                                </div>
                                <div className="BlogContain">
                                    <ul>
                                        <li>Digital Marketing, HubSpot Sales, CRM & Marketing, Lead Generation Strategy, HubSpot 2023</li>
                                         <li><div className='blogConatainWithPara'> AuthorCaryn Oram <p>DateFebruary 08, 2023</p></div></li>
                                    </ul>
                                    
                                    <h3>THE ROLE OF DATA IN DIGITAL MARKETING 
                                    IN 2023</h3>
                                </div>
                            </div>
                        </div>
                        <div className="col LatestBlogCol">
                            <div className="mainAreaBlog">
                                <div className="BlogImgArea">
                                    <img src={dummy} alt="" />
                                </div>
                                <div className="BlogContain">
                                    <ul>
                                        <li>Digital Marketing, HubSpot Sales, CRM & Marketing, Lead Generation Strategy, HubSpot 2023</li>
                                         <li><div className='blogConatainWithPara'> AuthorCaryn Oram <p>DateFebruary 08, 2023</p></div></li>
                                    </ul>
                                    
                                    <h3>THE ROLE OF DATA IN DIGITAL MARKETING 
                                    IN 2023</h3>
                                </div>
                            </div>
                        </div>
                        <div className="col LatestBlogCol">
                            <div className="mainAreaBlog">
                                <div className="BlogImgArea">
                                    <img src={dummy} alt="" />
                                </div>
                                <div className="BlogContain">
                                    <ul>
                                        <li>Digital Marketing, HubSpot Sales, CRM & Marketing, Lead Generation Strategy, HubSpot 2023</li>
                                         <li><div className='blogConatainWithPara'> AuthorCaryn Oram <p>DateFebruary 08, 2023</p></div></li>
                                    </ul>
                                    
                                    <h3>THE ROLE OF DATA IN DIGITAL MARKETING 
                                    IN 2023</h3>
                                </div>
                            </div>
                        </div>
                        <div className="col LatestBlogCol">
                            <div className="mainAreaBlog">
                                <div className="BlogImgArea">
                                    <img src={dummy} alt="" />
                                </div>
                                <div className="BlogContain">
                                    <ul>
                                        <li>Digital Marketing, HubSpot Sales, CRM & Marketing, Lead Generation Strategy, HubSpot 2023</li>
                                         <li><div className='blogConatainWithPara'> AuthorCaryn Oram <p>DateFebruary 08, 2023</p></div></li>
                                    </ul>
                                    
                                    <h3>THE ROLE OF DATA IN DIGITAL MARKETING 
                                    IN 2023</h3>
                                </div>
                            </div>
                        </div>
                        <div className="col LatestBlogCol">
                            <div className="mainAreaBlog">
                                <div className="BlogImgArea">
                                    <img src={dummy} alt="" />
                                </div>
                                <div className="BlogContain">
                                    <ul>
                                        <li>Digital Marketing, HubSpot Sales, CRM & Marketing, Lead Generation Strategy, HubSpot 2023</li>
                                         <li><div className='blogConatainWithPara'> AuthorCaryn Oram <p>DateFebruary 08, 2023</p></div></li>
                                    </ul>
                                    
                                    <h3>THE ROLE OF DATA IN DIGITAL MARKETING 
                                    IN 2023</h3>
                                </div>
                            </div>
                        </div>
                        <div className="col LatestBlogCol">
                            <div className="mainAreaBlog">
                                <div className="BlogImgArea">
                                    <img src={dummy} alt="" />
                                </div>
                                <div className="BlogContain">
                                    <ul>
                                        <li>Digital Marketing, HubSpot Sales, CRM & Marketing, Lead Generation Strategy, HubSpot 2023</li>
                                         <li><div className='blogConatainWithPara'> AuthorCaryn Oram <p>DateFebruary 08, 2023</p></div></li>
                                    </ul>
                                    
                                    <h3>THE ROLE OF DATA IN DIGITAL MARKETING 
                                    IN 2023</h3>
                                </div>
                            </div>
                        </div>
                        <div className="col LatestBlogCol">
                            <div className="mainAreaBlog">
                                <div className="BlogImgArea">
                                    <img src={dummy} alt="" />
                                </div>
                                <div className="BlogContain">
                                    <ul>
                                        <li>Digital Marketing, HubSpot Sales, CRM & Marketing, Lead Generation Strategy, HubSpot 2023</li>
                                         <li><div className='blogConatainWithPara'> AuthorCaryn Oram <p>DateFebruary 08, 2023</p></div></li>
                                    </ul>
                                    
                                    <h3>THE ROLE OF DATA IN DIGITAL MARKETING 
                                    IN 2023</h3>
                                </div>
                            </div>
                        </div>
                        <div className="col LatestBlogCol">
                            <div className="mainAreaBlog">
                                <div className="BlogImgArea">
                                    <img src={dummy} alt="" />
                                </div>
                                <div className="BlogContain">
                                    <ul>
                                        <li>Digital Marketing, HubSpot Sales, CRM & Marketing, Lead Generation Strategy, HubSpot 2023</li>
                                         <li><div className='blogConatainWithPara'> AuthorCaryn Oram <p>DateFebruary 08, 2023</p></div></li>
                                    </ul>
                                    
                                    <h3>THE ROLE OF DATA IN DIGITAL MARKETING 
                                    IN 2023</h3>
                                </div>
                            </div>
                        </div>
                        <div className="col LatestBlogCol">
                            <div className="mainAreaBlog">
                                <div className="BlogImgArea">
                                    <img src={dummy} alt="" />
                                </div>
                                <div className="BlogContain">
                                    <ul>
                                        <li>Digital Marketing, HubSpot Sales, CRM & Marketing, Lead Generation Strategy, HubSpot 2023</li>
                                         <li><div className='blogConatainWithPara'> AuthorCaryn Oram <p>DateFebruary 08, 2023</p></div></li>
                                    </ul>
                                    
                                    <h3>THE ROLE OF DATA IN DIGITAL MARKETING 
                                    IN 2023</h3>
                                </div>
                            </div>
                        </div>
                        <div className="col LatestBlogCol">
                            <div className="mainAreaBlog">
                                <div className="BlogImgArea">
                                    <img src={dummy} alt="" />
                                </div>
                                <div className="BlogContain">
                                    <ul>
                                        <li>Digital Marketing, HubSpot Sales, CRM & Marketing, Lead Generation Strategy, HubSpot 2023</li>
                                         <li><div className='blogConatainWithPara'> AuthorCaryn Oram <p>DateFebruary 08, 2023</p></div></li>
                                    </ul>
                                    
                                    <h3>THE ROLE OF DATA IN DIGITAL MARKETING 
                                    IN 2023</h3>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                </>
            )
            case 'Tab2':
            return (
                <h1>juzer</h1>
            )
            case 'Tab3':
            return (
                <h1>chee</h1>
            )
            case 'Tab4':
            return (
                <h1>wala</h1>
            )
        }
    }


  return (
    <>
      <Top_heading Heading="BLOGS"/>

      <Main_Heading SideHeading="AWARD-WINNING 
DIGITAL MARKETING 
AGENCY DESIGNED 
TO DRIVE"
        ButtonText="Share Your Project" 
        para1="Digital Marketing Services that are aligned to your business' growth targets
By implementing a strategy-first approach, our team identifies the right approach aligned to 
the goals of your business. This process includes a full competitor audit together with an outline of the messaging, content and services required to achieve your business' growth targets."
        para2="Our digital marketing strategies are designed to meet the customer where they are at in the 
buyer's journey and ultimately convert them into loyal customers and long standing brand advocates. This is done through smart and personalized digital marketing services, creative 
thinking and transformative technology, ensuring effective and measurable results."
        para3="If your business has clear growth targets, partner with NEXA to achieve these.This is done 
through smart and personalized digital marketing services, creative thinking and transformative technology, ensuring effective and measurable results." />



      <Component_Heading heading="OUR NEW & LATEST BLOGS"
      para="Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim 
ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. "
      />

<div className="contaiiner Glipse_work-tabs-main">
        <div className="tabs-container">
            <ul className="tabs-contain-area">
                <li className='main-list-tab'>
                <div className="heading-button">
                        <div className="button-design1">
                            <button onClick={() => handleTabClick('Tab1')} autoFocus>Social Media Posts</button>
                        </div>
                    </div>
                </li>
                <li className='main-list-tab'>
                <div className="heading-button">
                        <div className="button-design1">
                            <button onClick={() => handleTabClick('Tab2')}>Logo Designs</button>
                        </div>
                    </div>
                </li>
                <li className='main-list-tab'>
                <div className="heading-button">
                        <div className="button-design1">
                            <button onClick={() => handleTabClick('Tab3')}>Flyer Designs</button>
                        </div>
                    </div>
                </li>
                <li className='main-list-tab'>
                <div className="heading-button">
                        <div className="button-design1">
                            <button onClick={() => handleTabClick('Tab4')}>Website Designs</button>
                        </div>
                    </div>
                </li>
                <li className='main-list-tab'>
                <div className="heading-button">
                        <div className="button-design1">
                            <button onClick={() => handleTabClick('Tab5')}>Brochure Designs</button>
                        </div>
                    </div>
                </li>
                <li className='main-list-tab'>
                <div className="heading-button">
                        <div className="button-design1">
                            <button onClick={() => handleTabClick('Tab6')}>UI/UX Design</button>
                        </div>
                    </div>
                </li>
                <li className='main-list-tab'>
                <div className="heading-button">
                        <div className="button-design1">
                            <button onClick={() => handleTabClick('Tab7')}>Business Card</button>
                        </div>
                    </div>
                </li>
                <li className='main-list-tab'>
                <div className="heading-button">
                        <div className="button-design1">
                            <button onClick={() => handleTabClick('Tab8')}>Mockups</button>
                        </div>
                    </div>
                </li>
                <li className='main-list-tab'>
                <div className="heading-button">
                        <div className="button-design1">
                            <button onClick={() => handleTabClick('Tab9')}>Others</button>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    {renderContent()}

    </>
  )
}
